<div
  *ngIf="currentScope"
  class="change-request-overview">
  <scope-by-work-table
    [isEditable]="isEditable"
    [scopeVersion]="currentScope"
    [currentChangeRequest]="currentChangeRequest"
    [feeMenuOptions]="feeMenuOptions"
    [deliverableMenuOptions]="deliverableMenuOptions"
    [componentMenuOptions]="componentMenuOptions"
    [currentRatecard]="currentRatecard"
    [mainColumnClass]="mainColumnClass"
    [componentMainColumnClass]="componentMainColumnClass"
    [roleMainColumnClass]="roleMainColumnClass"
    [sortedSections]="sections"
    [sortedDefaultSectionDeliverables]="deliverables"
    [cdnConfig]="cdnConfig"
    [scopeFees$]="scopeFees$"
    [scopeRetainedHoursStats]="scopeRetainedHoursStats"
    [showUseRetainedTeamToggle]="showUseRetainedTeamToggle"
    (onAddScopeFee)="addScopeFee()"
    (onDeleteSection)="deleteSection($event)"
    (onFetchDeliverable)="fetchDeliverable($event)"
    (onUpdateDeliverable)="updateDeliverable($event)"
    (onUpdateComponent)="updateComponent($event)"
    (onDeleteDeliverable)="onDeleteDeliverable.emit($event)"
    (onAddDeliverableFee)="addDeliverableFee($event)"
    (onUpdateFeeItem)="updateFeeItem($event)"
    (onUpdateRole)="updateRole($event)" />
</div>
